
export default class Teste {
    constructor(restResponse) {
        this.dtHrPausa = restResponse.dtHrPausa,
        this.dataCriacao = restResponse.dataCriacao, 
        this.tipoQuestoes = restResponse.tipoQuestoes,
        this.idTeste =restResponse.idTeste,
        this.idUsuario = restResponse.idUsuario,
        this.modoTeste = restResponse.modoTeste,
        this.nome = restResponse.nome,
        this.qtdQuestoes = restResponse.qtdQuestoes,
        this.questoesList = restResponse.questoesList,
        this.status = restResponse.status, 
        this.exibirCronometro = false, 
        this.respostasValidadas = []
        this.respostaUsuario = restResponse.respostaUsuario, 
        this.favorito = restResponse.favorito
        this.acerto = restResponse.acerto
    }
}